/**
 * Personal-email domain set — shared by FE components that need to
 * collapse personal addresses (gmail, yahoo, etc.) into a single
 * "Personal email" bucket. Keep in sync with the BE sibling at
 * server/utils/personalEmailDomains.js — both files MUST use the
 * SAME literal list so the FE matcher and BE aggregation agree.
 */

export const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'icloud.com',
  'aol.com',
  'me.com',
  'msn.com',
  'live.com',
  'comcast.net',
]);

export const PERSONAL_EMAIL_BUCKET_LABEL = 'Personal email';
